export default class BaseModel {
  constructor(type, data) {
    this.__typename = data.__typename || type.name;
  }

  withoutTypename() {
    const obj = { ...this };
    delete obj.__typename;
    return obj;
  }
}
